// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification_notification__irnGb","button":"notification_button__R5h1c","img":"notification_img__f5jfZ"};